const dispatchEvent = (eventName, detail) => {
  document.dispatchEvent(new CustomEvent(eventName, { detail }));
};

export default dispatchEvent;
